import {
  Checkbox,
  CheckboxGroup,
  CheckboxGroupProps,
  CheckboxIcon,
  CheckboxProps,
} from "@nextui-org/checkbox";

const ZCheckbox = ({ children, ...props }: CheckboxProps) => {
  return <Checkbox {...props}>{children}</Checkbox>;
};

const ZCheckboxGroup = ({ children, ...props }: CheckboxGroupProps) => {
  return <CheckboxGroup {...props}>{children}</CheckboxGroup>;
};

export { ZCheckbox, ZCheckboxGroup, CheckboxIcon as ZCheckboxIcon };
